<template>
  <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px" class="app-container view-container" style="margin-bottom:20px">
    <BjDivider>
      {{ $t('CustomerFunction.common.Returndetails') }}
      <template slot="right">
        <el-button @click="cancel()">{{ $t('backText') }}</el-button>
        <el-button @click="onDownload()">{{ $t('labelDownloadText') }}</el-button>
        <el-button type="primary" @click="showLog">{{$t('BusinessPurchaseApplyDetail.operationLog') }}</el-button>
      </template>
    </BjDivider>
    <template>
      <el-row>
        <div class="bj-row mt10 mb10">
          <div class="bj-col-11">
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('billingPage.CustomerName') }}</div>
              <div class="bj-form-item-value">{{ form.customName }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('CustomerFunction.common.logisticsNo') }}</div>
              <div class="bj-form-item-value">{{ form.logisticsNumber }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('CustomerFunction.common.SubmissionTime') }}</div>
              <div class="bj-form-item-value">{{ form.applyDate | timeFilters }}</div>
            </div>
          </div>
          <div class="bj-col-1"></div>
          <div class="bj-col-12">
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('CustomerFunction.common.Status') }}</div>
              <div class="bj-form-item-value">{{ $t(CSG_RETURN_LIST_ADMIN_CLOSE.bjGet(form.status)) }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('CustomerFunction.common.associatedCode') }}</div>
              <div class="bj-form-item-value">{{ form.associatedCode }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('CustomerFunction.common.ConfirmTime') }}</div>
              <div class="bj-form-item-value">{{ form.auditDate | timeFilters }}</div>
            </div>
          </div>
        </div>
        <BjDivider>{{ $t('CustomerFunction.common.ApplicationList') }}</BjDivider>
        <el-table :data="form.applySkuList" border script max-height="600">
          <el-table-column :label="$t('table.countText')" type="index" width="55" align="center" />
          <el-table-column prop="standardSkuCode" label="SKU" align="center" />
          <el-table-column prop="barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" align="center" />
          <el-table-column prop="returnTotal" :label="$t('UploadTotalText')" align="center" />
           <el-table-column prop="nonDefectiveHandling" :label="$t('CustomerFunction.table.GoodQuality')" align="center">
            <template v-slot="{ row }">
                {{$t(CSG_RETURN_LIST_ADMIN_STATUS.bjGet(row.nonDefectiveHandling)) }}
            </template>
          </el-table-column>
          <el-table-column prop="defectiveHandling" :label="$t('CustomerFunction.table.HandlingOf')" align="center">
            <template v-slot="{ row }">
                {{$t(CSG_RETURN_LIST_ADMIN_STATUS.bjGet(row.defectiveHandling)) }}
            </template>
          </el-table-column>
        </el-table>
        <template v-if="form.confirmSkuList && form.confirmSkuList.length>0">
          <BjDivider>{{ $t('CustomerFunction.common.ConfirmList') }}</BjDivider>
          <el-table :data="form.confirmSkuList" border script max-height="600">
            <el-table-column :label="$t('table.countText')" type="index" width="55" align="center" />
            <el-table-column prop="standardSkuCode" label="SKU" align="center" />
            <el-table-column prop="barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" align="center" />
            <el-table-column prop="returnTotal" :label="$t('UploadTotalText')" align="center" />
            <el-table-column prop="nonDefectiveNumber" :label="$t('CustomerFunction.common.Quantityof')" align="center" />
            <el-table-column prop="nonDefectiveHandling" :label="$t('CustomerFunction.table.GoodQuality')" align="center">
              <template v-slot="{ row }">
                  {{$t(CSG_RETURN_LIST_ADMIN_STATUS.bjGet(row.nonDefectiveHandling)) }}
              </template>
            </el-table-column>
            <el-table-column prop="defectiveNumber" :label="$t('CustomerFunction.common.Quantityofdefective')" align="center" />
            <el-table-column prop="defectiveHandling" :label="$t('CustomerFunction.table.HandlingOf')" align="center">
              <template v-slot="{ row }">
                  {{$t(CSG_RETURN_LIST_ADMIN_STATUS.bjGet(row.defectiveHandling)) }}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-row>
    </template>
    <template v-if="form.materialList && form.materialList.length>0">
      <BjDivider>{{ $t('CustomerFunction.common.AttachmentInformation') }}</BjDivider>
      <div class="mt20">
        <div class="flex">
          <div v-for="(imageUrl, index) in form.materialList" :key="index" class="imageViewer">
            <BjKeyImage height="148px" width="148px" :url="normalizeDownloadUrl(imageUrl.detailImage)" style="margin: 10px" preview />
            <div class="flex flex-spacearound">
              <i class="el-icon-download yellow" @click="downloadImage(imageUrl.detailImage)"></i>
              <!-- <i v-if="!$store.getters.cusId" class="el-icon-delete red" @click="deleteImage(imageUrl.detailImage)"></i> -->
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-form>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { thirdReturnApi, orderApi } from '@/api';
import BjUpload from '@/components/BjUpload/index';
import { CSG_RETURN_LIST_ADMIN_CLOSE, CSG_RETURN_LIST_ADMIN_STATUS } from '@/utils/constants';
import orderLog from '@/utils/log.js';
export default {
  name: 'BusinessAfterReturnView',
  components: {
    BjUpload,
  },
  mixins: [viewMiXin],
  data() {
    return {
      CSG_RETURN_LIST_ADMIN_CLOSE,
      CSG_RETURN_LIST_ADMIN_STATUS,
      colSpan: 12,
      form: {},
      updateImages: [],
      comment: null,
      rules: {},
    };
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      orderApi.detail({ returnInfoId: this.$route.query.id }).then(res => {
        this.form = res;
      });
    },
    // 下载PDF（批量）
    onDownload() {
      orderApi.createAuPostReturnOrder({ outerOrderNo: encodeURIComponent(this.form.platformNo) }).then(res => {
        if (!Array.isArray(res) || res.length === 0) return;
        res.forEach((url, index) => {
          setTimeout(() => {
            const fullUrl = this.normalizeDownloadUrl(url);
            const link = document.createElement('a');
            link.href = fullUrl;
            link.target = '_blank';
            link.download = fullUrl.substring(fullUrl.lastIndexOf('/') + 1);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }, index * 500);
        });
      });
    },
    // 打开日志
    showLog() {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
          actionApi: orderApi.operateLogs,
          defaultQuery: {
            returnInfoId: this.$route.query.id
          },
          columns: [
            {
              prop: 'operationName',
              label: 'BjDialogListConfig.Operator',
            },
            {
              prop: 'creationDate',
              label: 'BjDialogListConfig.Operationtime',
            },
            {
              prop: 'operation',
              label: 'BjDialogListConfig.Remarks',
            },
          ],
        }),
      );
    },
    deleteImage(file) {
      this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
        this.form.thirdPartyReturnOrderMaterialList.splice(
          this.form.thirdPartyReturnOrderMaterialList.findIndex(e => e.detailImage === file),
          1,
        );
        this.form.thirdPartyReturnOrderMaterialList = this.form.thirdPartyReturnOrderMaterialList.map(item => {
          return { detailImage: item.detailImage };
        });
        setTimeout(() => {
          this.editApi(this.form);
        }, 300);
      }).catch(_ => { });
    },
    // 截取下载的图片名
    imageFileName(url) {
      const urlObj = new URL(url);
      // 获取路径名部分（包括查询参数和哈希值之前的部分）
      const pathname = urlObj.pathname;
      // 使用最后一个'/'字符将路径名分割成目录和文件名两部分
      const parts = pathname.split('/');
      // 提取出文件名
      const fileName = parts.pop();
      // 如果文件名包含查询参数或哈希值，使用'?'或'#'字符将其分割出来
      const fileNameWithoutQueryOrHash = fileName.split('?')[0].split('#')[0];
      return fileNameWithoutQueryOrHash;
    },
    // 下载图片
    downloadImage(url) {
      if (!url) return;
      url = this.normalizeDownloadUrl(url);
      const fileName = this.imageFileName(url);
      this.downloadImageUrl(url, fileName);
    },
    // 获取 上传的 新数据 并 合并到旧数据
    afterUpload(url) {
      this.updateImages.push({ detailImage: url });
    },
    onRemoveUrl(file) {
      this.updateImages.splice(
        this.updateImages.findIndex(e => e.detailImage === file.url),
        1,
      );
    },
    /** 确定 */
    onConfirm() {
      if (this.updateImages.length) {
        this.form.thirdPartyReturnOrderMaterialList = this.form.thirdPartyReturnOrderMaterialList.map(item => {
          return { detailImage: item.detailImage };
        });
        this.updateImages.forEach(item => this.form.thirdPartyReturnOrderMaterialList.push(item));
      }
      this.form.comment = this.comment;
      this.editApi(this.form);
    },

    editApi(API_DATA) {
      delete API_DATA.createdBy;
      delete API_DATA.lastUpdatedBy;
      thirdReturnApi.editThirdPartyReturnOrder(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            // this.getData();
            this.$refs.BjUpload.fileList = [];
            this.updateImages = [];
            this.comment = null;
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  .imageViewer {
    display: flex;
    flex-direction: column;
    align-items: center;
    .yellow {
      color: #ff8f40;
      cursor: pointer;
      font-size: 18px;
    }
  }
}
</style>
